import { render, staticRenderFns } from "./VendorTabs.vue?vue&type=template&id=78c05aa4&"
import script from "./VendorTabs.vue?vue&type=script&lang=js&"
export * from "./VendorTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports